import React, { Fragment } from 'react';
import { useTranslation } from 'react-i18next';
import NewsService from '../../services/news.service';
import models_V2Service from '../../services/models_V2.service';
import ComponentTable from '../../components/ComponentTable';
import { useDispatch, useSelector } from 'react-redux';
import { openRequestModal } from '../../actions/modals';
import VisibilityIcon from '@mui/icons-material/Visibility';

export default function UserNewsComponent(props) {
    const { t } = useTranslation();
    const dispatch = useDispatch();

    const actions = [
        {
            title: t('news.view'),
            onClick: id =>
                dispatch(
                    openRequestModal({
                        opened: true,
                        data: {
                            id: id,
                            header: t('news.viewNews'),
                            modaltype: 'ViewNews',
                        },
                    })
                ),
            Icon: VisibilityIcon,
        },
    ];

    return (
        <Fragment>
            <ComponentTable
                source={{
                    getData: (page, size, sort, filter) =>
                        NewsService.GetAllNewsUser(false, {
                            page: page || 0,
                            size: size || 10,
                            orderBy: (sort && sort.orderBy) || null,
                            order: (sort && sort.order) || 'asc',
                            filter,
                        }),
                    getModel: () => models_V2Service.getNewsUser(),
                }}
                actions={actions}
                selectable={true}
                enableFilter
                title={t('modals.list')}
                enableSettings
                toolbarvisible={true}
                typeTable="moneybox"
            />
        </Fragment>
    );
}
